import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Menu, ProSidebar, SidebarContent } from 'react-pro-sidebar';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { Box } from '@material-ui/core';
import NavSection from '../aisle/NavSection';
import '../style/sidebar.scss';
import growzMenu from './menu';
import StoreSwitcher from '../components/StoreSwitcher';
import ProductSwitcher from '../components/ProductSwitcher';
import AgencyLogo from './AgencyLogo';
import ProgressBar from '../../components/common/growz/ProgressBar';
import { ArrowForward as ArrowForwardIcon } from '@material-ui/icons';
import { _route } from '../../utils';

SideBar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function SideBar() {
  const history = useHistory();
  const { store } = useSelector(({ auth }) => auth);
  const { menuCollapsed } = useSelector(({ layout }) => layout);
  const [menuId, setMenuId] = useState(0);
  const { pathname } = useLocation();
  const { profile, onboardingDone, amazonElevate } = store;
  let growzMenuFiltered = growzMenu;

  useEffect(() => {
    if (pathname.includes('/growz/reports/')) {
      setMenuId(3);
    }
    if (pathname.includes('/growz/asin/')) {
      setMenuId(10);
    }
  }, [pathname]);

  if (menuId) {
    growzMenuFiltered = growzMenuFiltered.find((menu) => menu.menuId === menuId);
    if (growzMenuFiltered?.hasNestedMenu) growzMenuFiltered = growzMenuFiltered.menu;
  }

  const renderContent = (
    <>
      <Box style={{ padding: '16px 20px 24px 16px', height: '72px' }}>
        <AgencyLogo />
      </Box>

      {!menuCollapsed && (
        <Box style={{ padding: '10px 16px' }}>
          <StoreSwitcher realm="growz" />
        </Box>
      )}

      <Menu className={menuCollapsed ? 'collasped_menu_list' : 'expanded_menu_list'}>
        <NavSection
          navConfig={growzMenuFiltered}
          user={profile && onboardingDone}
          open={menuCollapsed}
          setMenuId={setMenuId}
        />
      </Menu>

      {profile && onboardingDone && (
        <div
          style={{
            position: 'fixed',
            bottom: '0',
            padding: '16px 16px 24px',
            left: '0',
            width: '220px',
            background: '#101828',
          }}
        >
          {store?.checklist?.['growz-checklist'] !== 100 && menuId !== 3 && (
            <div
              style={{
                background: '#344054',
                border: '2px solid rgba(255, 255, 255, 0.12)',
                borderRadius: '8px',
                padding: '6px 4px',
              }}
            >
              <div className="flexCenter" style={{ justifyContent: 'flex-start' }}>
                <div>
                  <ProgressBar
                    value={store?.checklist?.['growz-checklist'] ?? 10}
                    color="#FFD7D7"
                    bgColor="#475467"
                    size={40}
                    thickness={4}
                    fontSize="11px"
                  />{' '}
                </div>
                <div style={{ marginLeft: '6px' }}>
                  <div
                    style={{ fontStyle: 'normal', fontWeight: 500, fontSize: '13px', lineHeight: '20px', color: '#FFFFFF' }}
                  >
                    Finish your account Setup Guide
                  </div>
                  <div
                    style={{
                      marginTop: '4px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      fontSize: '13px',
                      lineHeight: '20px',
                      color: '#C4B9FF',
                      cursor: 'pointer',
                    }}
                    onClick={() => history.push(_route('growz.overview'))}
                  >
                    Complete Setup <ArrowForwardIcon style={{ verticalAlign: 'middle', width: '18px' }} />
                  </div>
                </div>
              </div>
            </div>
          )}

          {!amazonElevate && (
            <>
              <div style={{ borderTop: '1px solid #202d48', margin: '1rem 0' }}></div>
              <ProductSwitcher />
            </>
          )}
        </div>
      )}
    </>
  );

  return (
    <ProSidebar collapsed={menuCollapsed} className="main-menu">
      <SidebarContent>{renderContent}</SidebarContent>
    </ProSidebar>
  );
}
